export default __webpack_public_path__ + "static/media/Home-foto-header-corporate-Tower-viajes-mobile@2x.640b3607.jpg";